import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  FadeWrapper,
  LandingPageHero,
} from '../../../../components';

import {
  DEFAULT_LANGUAGE,
  NL_NEWS_KNOWLEDGE_URL,
  EN_NEWS_KNOWLEDGE_URL,
  NL_THEMES_URL,
  EN_THEMES_URL,
} from '../../../../config/constants';

const ALLOWED_WIDE_PARAGRAPHS = [
  'video',
  'accordeon',
  'link_list',
];

import './style.scss';

const TaxonomyThemes = ({ entity }) => {
  const { t } = useTranslation();

  const image = entity.getIn(['field_media_item', 0]);
  const title = entity.getIn(['name', 0, 'value']);
  const body = entity.getIn(['description', 0, 'value']);
  const langcode = entity.getIn(['langcode', 0, 'value']);
  const themesUrl = langcode === DEFAULT_LANGUAGE ? NL_THEMES_URL : EN_THEMES_URL;
  const newsUrl = langcode === DEFAULT_LANGUAGE ? NL_NEWS_KNOWLEDGE_URL : EN_NEWS_KNOWLEDGE_URL;

  return (
    <div className="TaxonomyTheme">
      <Container>
        <LandingPageHero
          title={title}
          body={body}
          image={image}
          breadcrumbsData={[
            { url: `/${langcode}/${newsUrl}`, title: t('general.news_and_knowledge') },
            { url: `/${langcode}/${newsUrl}/${themesUrl}`, title: t('general.themes') },
            { title: title },
          ]}
        />
      </Container>

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const paragraphType = paragraph.getIn(['entity', 'type', 0, 'target_id']);
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                  wide={ALLOWED_WIDE_PARAGRAPHS.includes(paragraphType)}
                />
              </FadeWrapper>
            );
          })}
        </div>
      )}
      {/* End of paragraphs */}

    </div>
  );
};

export default TaxonomyThemes;
